export default __webpack_public_path__ + "paras@2x.09dc11ac.png";